import { WATER_TYPE_IDS } from "@constants/global.constants";
import { UNIT_TYPES } from "@constants/units.constant";

export const MAX_TEMP_CELCIUS = 100;
// #141828 IF TDS is less than this, then it will be consider, there is no water chemistry
export const NO_WATER_CHEMISTRY_TDS_DELTA = 0.1;
export const MAX_TEMP_CELCIUS_WARNING = 40;
export const VALIDATION_DELAY_MS = 3000;
export const SYSTEM_DIAGRAM_HIDE_SHOW_MSG_TIMER = 3000;
export const DEFAULT_DUPONT_TEMP = 35; // Default temperature in Celsius
export const COMPANY_CODE = { 1: "DUPONT", 2: "INGE" };
export const pUF_TECH_ID = { DUPONT: 1, INGE: 2 };
export const UF_MODULE_PER_RACK_RANGE = { min: 6, max: 22 };
export const UF_CHEM_ADJUSTMENT_SCREEN = "CHEMICAL_ADJUSTMENT_DIALOG_SCREEN";
export const UF_CHEMICAL_SCREENS = { CEB: "CEB", MINI_CIP: "MiniCIP", CIP: "CIP", BW: "BW" };
export const WATER_TYPES_OFFLINE_TRAINS = { DRINKNG: 12, NON_DRINKING: 0 };

export const DISABLED_INPUTS = ["Automatic", "Aeration Air Flow", "Disinfection CEB"];
export const UF_STANDBY_OPTION = { FILTRATE_TANK: 1, BACKWASH_TANK: 2 };

export const UF_STANDBY_OPTIONS = [{ standByOptionID: 1 }, { standByOptionID: 2 }];
export const UF_STORAGE_TANK_OPTIONS = [{ storageTankOptionID: 1 }, { storageTankOptionID: 2 }];
export const DEFAULT_WATER_TYPE_ID = 5;
export const DEFAULT_WATER_SUB_TYPE_ID = 51;

export const UF_BACKWASH_PROTOCOL_ID = {
  UXA: 1,
  NORMAL: 2,
  SPLIT: 3,
};

export const UF_BACKWASH_PROTOCOL_OPTIONS = [
  { ufbwProtocolID: UF_BACKWASH_PROTOCOL_ID.UXA },
  { ufbwProtocolID: UF_BACKWASH_PROTOCOL_ID.NORMAL },
  { ufbwProtocolID: UF_BACKWASH_PROTOCOL_ID.SPLIT },
];

export const UF_CHEMICAL_SCREENS_LABELS = {
  [UF_CHEMICAL_SCREENS.CEB]: "CEB",
  [UF_CHEMICAL_SCREENS.MINI_CIP]: "mini-CIP",
  [UF_CHEMICAL_SCREENS.CIP]: "CIP",
  [UF_CHEMICAL_SCREENS.BW]: "BW",
};

export const UF_SPECIAL_FEATURE = {
  isCebOnly: "1",
  isMiniCipOnly: "2",
  isCebAndMiniCip: "3",
};

export const FIELD_OFFLINE_TIME_PER_TRAIN = {
  defaultValue: 0,
  minValue: 0,
  maxValue: 60,
  softLowerLimit: 2,
  softUpperLimit: 30,
  uom: "min/d",
};

export const MODULE_COMPANY_NAMES = {
  DUPONT: "DuPont",
  INGE_MB_07: "Inge MB 0.7",
  INGE_MB_09: "Inge MB 0.9",
  INGE_MB_15: "Inge MB 1.5",
};

export const UFTechnologies = t => [
  {
    pUFTechnologyID: 1,
    companyName: "DuPont",
    pUFTechName: t("ufDesign.outIn"),
  },
  {
    pUFTechnologyID: 2,
    companyName: "Inge",
    pUFTechName: t("ufDesign.inOut"),
  },
];

export const UF_MODULE_TABLE_CONFIG = t => [
  { id: 1, title: t("ufProducts.moduleName"), field: "moduleName", filter: true, width: "200px" }, // Added width for module name
  { id: 1.1, title: t("ufProducts.oldModuleName"), field: "oldModuleName", width: "200px" }, // old name column , not used currently
  { id: 2, title: t("ufProducts.fiberMaterial"), field: "fberMat" },
  { id: 3, title: t("ufProducts.operationMode"), field: "flowPattern" },
  { id: 4, title: t("ufProducts.moduleArea"), field: "moduleArea" },
  { id: 5, title: t("ufProducts.length"), field: "moduleLength" },
  { id: 6, title: t("ufProducts.rackOpenPlatform"), field: "integrated", width: "110px" },
  { id: 7, title: t("ufProducts.orientation"), field: "orientation" },
  { id: 8, title: t("ufProducts.innerDiameter"), field: "bores" },
];

export const UF_MODULE_IDS = {
  MODULE_XTP_100_IG: 60,
};

export const MODULE_TYPES = {
  RACK: "rack",
  OPEN_PLATFORM: "open_platform",
  DRINKING_WATER: "drinking_water",
  NON_DRINKING_WATER: "non_drinking_water",
  OBSOLETE: "obsolete",
  CHINESE: "chinese",
};

//string constants

export const ERR_MSGS = {
  ACID_CEB_DOSE_ERROR:
    "The values for both Mineral and Organic Acid Dose are 0. To continue, please adjust at least one of the doses amounts to a value greater than 0 in the CEB display.",
  ALKALI_CEB__DOSE_ERROR:
    "The values for both CEB Alkali and CEB Oxidant Dose are 0. To continue, please adjust at least one of the doses amounts to a value greater than 0 in the CEB display.",
  CIP_DOSE_ERROR:
    "The value for CIP chemical doses are currently 0. To continue, please adjust the at least one of the CIP chemical doses amounts to a value greater than 0 in the CIP display.",
  CIP_DESIGN_VALUE_ERROR:
    "The CIP design cycle interval is 0 , please update the value to a value greater than 0 in the design display",
  ALKALI_CEB_DESIGN_VALUE_ERROR:
    "The alkali/oxidant CEB design cycle interval is 0 , please update the value to a value greater than 0 in the design display",
  ACID_CEB_DESIGN_VALUE_ERROR:
    "The Acid CEB design cycle interval is 0 , please update the value to a value greater than 0 in the design display",
  MINI_CIP_DOSE_ERROR:
    "The value for mini-CIP chemical doses are currently 0. To continue, please adjust the at least one of the mini-CIP chemical doses amounts to a value greater than 0 in the mini-CIP display.",
  DIS_OXIDANT_CEB_DOSE_ERROR:
    "The value of Disinfectant oxidant Dose is 0, please adjust the dose amount to a value greater than 0 in the CEB display.",
  DIS_OXIDANT_DESIGN_VALUE_ERROR:
    "The disinfectant oxidant CEB design cycle interval is 0 , please update the value to a value greater than 0 in the design display",
};

/**
 * UF Module Constants
 *
 * MB 80 TR => 35
 * MB 70 WT => 36
 * MB 50 TR => 37
 * MB 60 TR S => 38
 * MB 40 TR S => 39
 * MB PRO 95 R => 57
 * MB Pro 82 TRs => 58
 */
export const INGE_MODULE_TR_LABEL_KEYS = {
  TR1: "configurations.singleSide2",
  TR2: "configurations.singleSide4",
  TR4: "configurations.doubleSide4",
};

const INGE_MODULE_TR_BASE_RANGES = {
  35: {
    TR1: { min: 4, max: 30 },
    TR2: { min: 16, max: 30 },
    TR4: { min: 16, max: 30 },
  },
  36: {
    TR1: { min: 4, max: 30 },
    TR2: { min: 16, max: 30 },
    TR4: { min: 16, max: 30 },
  },
  37: {
    TR1: { min: 4, max: 34 },
    TR2: { min: 18, max: 34 },
    TR4: { min: 18, max: 34 },
  },
  38: {
    TR1: { min: 4, max: 40 },
    TR2: { min: 8, max: 40 },
    TR4: { min: 8, max: 40 },
  },
  39: {
    TR1: { min: 4, max: 40 },
    TR2: { min: 8, max: 40 },
    TR4: { min: 8, max: 40 },
  },
  57: {
    TR1: { min: 4, max: 26 },
    TR2: { min: 14, max: 26 },
    TR4: { min: 14, max: 26 },
  },
  58: {
    TR1: { min: 4, max: 30 },
    TR2: { min: 8, max: 30 },
    TR4: { min: 8, max: 30 },
  },
  66: {
    //0.7 95 iTR
    TR1: { min: 4, max: 26 },
    TR2: { min: 14, max: 26 },
    TR4: { min: 14, max: 26 },
  },
  67: {
    //0.7 82 iTR
    TR1: { min: 4, max: 30 },
    TR2: { min: 8, max: 30 },
    TR4: { min: 8, max: 30 },
  },
  68: {
    //0.9 80 iTR
    TR1: { min: 4, max: 30 },
    TR2: { min: 16, max: 30 },
    TR4: { min: 16, max: 30 },
  },
  69: {
    // 0.9 60 iTR
    TR1: { min: 4, max: 40 },
    TR2: { min: 8, max: 40 },
    TR4: { min: 8, max: 40 },
  },
};

const getContainerizedModuleRanges = rangeSet => {
  const { TR4: _TR4, ...rangesWithoutTR4 } = rangeSet;
  return rangesWithoutTR4;
};

export const INGE_MODULE_TR_RANGES = {
  ...INGE_MODULE_TR_BASE_RANGES,
  72: getContainerizedModuleRanges(INGE_MODULE_TR_BASE_RANGES[35]),
  74: getContainerizedModuleRanges(INGE_MODULE_TR_BASE_RANGES[37]),
  70: getContainerizedModuleRanges(INGE_MODULE_TR_BASE_RANGES[57]),
  71: getContainerizedModuleRanges(INGE_MODULE_TR_BASE_RANGES[66]),
  73: getContainerizedModuleRanges(INGE_MODULE_TR_BASE_RANGES[68]),
};

const INGE_TR_OPTIONS_RANGE = {
  35: { TR1: 30, TR2: 60 },
  36: { TR1: 40 },
  37: { TR1: 34, TR2: 68 },
  38: { TR1: 40 },
  39: { TR1: 40 },
  57: { TR1: 26, TR2: 52 },
  58: { TR1: 30 },
  66: { TR1: 26, TR2: 52 },
  67: { TR1: 30 },
  68: { TR1: 30, TR2: 60 },
  69: { TR1: 40 },
};

const getContainerizedModuleTrOptionsRange = options => {
  const { TR2: _TR2, ...optionsWithoutTR2 } = options;
  return optionsWithoutTR2;
};

export const INGE_MODULE_TR_OPTIONS_RANGE = {
  ...INGE_TR_OPTIONS_RANGE,
  72: getContainerizedModuleTrOptionsRange(INGE_TR_OPTIONS_RANGE[35]),
  74: getContainerizedModuleTrOptionsRange(INGE_TR_OPTIONS_RANGE[37]),
  70: getContainerizedModuleTrOptionsRange(INGE_TR_OPTIONS_RANGE[57]),
  71: getContainerizedModuleTrOptionsRange(INGE_TR_OPTIONS_RANGE[66]),
  73: getContainerizedModuleTrOptionsRange(INGE_TR_OPTIONS_RANGE[68]),
};

export const INGE_MODULE_TR_MULTIPLIER = {
  TR1: 2,
  TR2: 4,
  TR4: 4,
};

export const INGE_MODULE_TR_RANGE_FACTOR = {
  TR1: 2,
  TR2: 4,
  TR4: 8,
};

export const MODULE_PER_UNITS_INGE_RANGE = {
  minValue: 1,
  maxValue: 120,
};

// key remains same for both inge and dupont
export const CHEMICAL_RANGES_KEY_MAPPING = {
  mineral: {
    [UF_CHEMICAL_SCREENS.CIP]: "CIP Mineral Acid Concentration",
    [UF_CHEMICAL_SCREENS.CEB]: "CEB Mineral Acid Concentration",
    [UF_CHEMICAL_SCREENS.MINI_CIP]: "CIP Mineral Acid Concentration",
  },
  organic: {
    [UF_CHEMICAL_SCREENS.CIP]: "CIP Organic Acid Concentration",
    [UF_CHEMICAL_SCREENS.CEB]: "CEB Organic Acid Concentration",
    [UF_CHEMICAL_SCREENS.MINI_CIP]: "mCIP Organic Acid Concentration",
  },
  alkali: {
    [UF_CHEMICAL_SCREENS.CIP]: "CIP Alkali Concentration",
    [UF_CHEMICAL_SCREENS.CEB]: "CEB Alkali Concentration",
    [UF_CHEMICAL_SCREENS.MINI_CIP]: "CIP Alkali Concentration",
  },
  oxidant: {
    [UF_CHEMICAL_SCREENS.CIP]: "CIP Oxidant Concentration",
    [UF_CHEMICAL_SCREENS.CEB]: "CEB Oxidant Concentration",
    [UF_CHEMICAL_SCREENS.MINI_CIP]: "mCIP Oxidant Concentration",
  },
  disOxidant: {
    [UF_CHEMICAL_SCREENS.CEB]: "Dis. CEB Oxidant",
  },
  oxidant2: {
    [UF_CHEMICAL_SCREENS.CIP]: "CIP SLS",
    [UF_CHEMICAL_SCREENS.MINI_CIP]: "CIP SLS",
  },
};

/**
 * Keeping constants on basis of company code
 */
export const TYPICAL_WAIT_DURATION = {
  1: "typicalWaitDuration_Dupont",
  2: "typicalWaitDuration_Inge",
  5: "Typical Wait Duration_Memcor",
};

export const TYPICAL_PUMP_RAMP = {
  1: "typicalPumpRamp_Dupont",
  2: "typicalPumpRamp_Inge",
  5: "Typical Pump Ramp_Memcor",
};

export const CHEMICAL_TYPES = {
  mineral: "mineral",
  alkali: "alkali",
  organic: "organic",
  oxidant: "oxidant",
  oxidant2: "oxidant2",
  disOxidant: "disOxidant",
};

export const UF_CHEMICAL_FIELDS = t => ({
  mineral: t("ufChemical.mineral"),
  organic: t("ufChemical.organic"),
  alkali: t("ufChemical.alkali"),
  oxidant: t("ufChemical.oxidant"),
  oxidant2: t("ufChemical.oxidant2"),
  disOxidant: t("ufChemical.disOxidant"),
});

export const UF_CHEMICAL_FIELDS_MAPPING = {
  mineral: "Acid",
  organic: "Organic Acid",
  alkali: "Base",
  oxidant: "Oxidant",
  oxidant2: "Surfactant",
  disOxidant: "Oxidant",
  coagulant: "Coagulant",
};

export const WATER_TYPES_LIMITS = {
  2: { turbidityLimit: 20, tssLimit: 40, tocLimit: 5 }, //"Softened
  3: { turbidityLimit: 20, tssLimit: 40, tocLimit: 5 }, //"Municipal"
  4: { turbidityLimit: 20, tssLimit: 40, tocLimit: 5 }, //"Well"
  5: { turbidityLimit: 20, tssLimit: 40, tocLimit: 8 }, //"Surface Water
  6: { turbidityLimit: 20, tssLimit: 40, tocLimit: 9 }, //"Sea Water"
  7: { turbidityLimit: 50, tssLimit: 100, tocLimit: 30 }, //"Waste Water"
};

// Limits for integrated prefilter modules (stricter than standard modules)
// Applicable for: Sea Water, Surface Water, Softened, Municipal, Well
// NOT applicable for: Waste Water, Backwash Water
export const INTEGRATED_PREFILTER_LIMITS = { turbidityLimit: 10, tssLimit: 20 };

// Water type IDs that support integrated prefilter modules
export const INTEGRATED_PREFILTER_ALLOWED_WATER_TYPES = [
  WATER_TYPE_IDS.SOFTENED_WATER,
  WATER_TYPE_IDS.MUNICIPAL_WATER,
  WATER_TYPE_IDS.WELL_WATER,
  WATER_TYPE_IDS.SEA_WATER,
  WATER_TYPE_IDS.SURFACE_WATER,
]; // Softened, Municipal, Well, Surface, Sea Water

/** UF water sources are persisted as type strings. Internal RO permeate additionally includes the source node ID. */
export const UF_WATER_SOURCE_TYPES = {
  PRE_TREATED: "PRE_TREATED",
  UF_FILTRATE: "UF_FILTRATE",
  RO_CONCENTRATE: "RO_CONCENTRATE",
  RO_PERMEATE_EXTERNAL: "RO_PERMEATE_EXTERNAL",
  RO_PERMEATE_INTERNAL: "RO_PERMEATE_INTERNAL",
};

export const UFCongurationTableHeader = t => [
  { field: "selectConfiguration", header: t("configurations.selectConfiguration") },
  { field: "onlineUnits", header: t("configurations.onlineUnits") },
  { field: "standbyUnits", header: t("configurations.standbyUnits") },
  { field: "totalUnits", header: t("configurations.totalUnits") },
  { field: "maxOfflineBWCEB", header: t("configurations.maxOfflineBWCEB") },
  { field: "modulesPerRack", header: t("configurations.modulesPerRack") },
  { field: "racksPerUnit", header: t("configurations.racksPerUnit") },
  { field: "modulesPerUnit", header: t("configurations.modulesPerUnit") },
  { field: "onlineModules", header: t("configurations.onlineModules") },
  { field: "totalModules", header: t("configurations.totalModules") },
];

export const ALKALI_CEB_PH_SEA_WATER_RANGES = {
  minValue: 7,
  maxValue: 10,
};

export const OXALIC_ACID_DEFAULT = 4000;

export const TURBIDITY_RANGES = {
  soft: { min: 0, max: 300 },
  hard: { min: 0, max: 1000 },
};

export const TSS_RANGES = {
  soft: { min: 0, max: 100 },
  hard: { min: 0, max: 1000 },
};

/* used dynamically to convert ufData to metric and from metric while fetching and saving data*/
export const UF_DATA_KEY_UNIT_MAPPING = {
  [UNIT_TYPES.TEMPERATURE]: ["recycleTemperature", "recycleTemperature_MiniCIP"],
  [UNIT_TYPES.PRESSURE]: [
    "maxAirScourPressure",
    "maxAirProcPressure",
    "filteratePressure",
    "nonIntegraPacTrainPresDrop",
    "integraPacFiltrationPreDrop",
    "backwashPipingPreDrop",
    "cIPPipingPreDrop",
    "backwash_Filtration",
    "acidCEB_Filtration",
    "alkaliCEB_Filtration",
    "cIP_Filtration",
    "miniCIP_Filtration",
  ],
  [UNIT_TYPES.FLUX]: ["filtrateFlux", "backwashFlux", "cEBFlux"],
  [UNIT_TYPES.FLOW]: ["forwardFlushFlow", "recycleFlowRate", "recycleFlowRate_MiniCIP"],
  [UNIT_TYPES.GAS_FLOW]: ["airFlow", "aerationAirFlow"],
  [UNIT_TYPES.POWER]: ["pLCPowerReqPertrain", "volvePowerReqPerTrain"],
};

export const UF_WATER_SOURCE_FIELD_BY_SCREEN = {
  [UF_CHEMICAL_SCREENS.CIP]: "waterSourceCIP",
  [UF_CHEMICAL_SCREENS.CEB]: "waterSourceCEB",
  [UF_CHEMICAL_SCREENS.MINI_CIP]: "waterSourceMCIP",
};

export const UF_WATER_SOURCE_BASE_TYPES_BW = [UF_WATER_SOURCE_TYPES.UF_FILTRATE];

export const UF_WATER_SOURCE_BASE_TYPES_BWFF = [UF_WATER_SOURCE_TYPES.PRE_TREATED, UF_WATER_SOURCE_TYPES.UF_FILTRATE];

export const UF_WATER_SOURCE_BASE_TYPES_CIP_CEB_MCIP = [UF_WATER_SOURCE_TYPES.UF_FILTRATE];

export const UF_WATER_SOURCE_FIELDS = [
  "waterSourceBW",
  "waterSourceBWFF",
  "waterSourceCEB",
  "waterSourceCIP",
  "waterSourceMCIP",
];

export const UF_WATER_SOURCE_MAPPING_BY_ID = {
  waterSourceCIP: {
    name: "waterSourceCIP",
    labelKey: "cipUF.waterSourceCIP",
    waterSourceTypes: UF_WATER_SOURCE_BASE_TYPES_CIP_CEB_MCIP,
  },
  waterSourceCEB: {
    name: "waterSourceCEB",
    labelKey: "ufDesign.cebWaterSource",
    waterSourceTypes: UF_WATER_SOURCE_BASE_TYPES_CIP_CEB_MCIP,
  },
  waterSourceMCIP: {
    name: "waterSourceMCIP",
    labelKey: "ufMiniCip.miniCIPWaterSource",
    waterSourceTypes: UF_WATER_SOURCE_BASE_TYPES_CIP_CEB_MCIP,
  },
  waterSourceBW: {
    name: "waterSourceBW",
    labelKey: "ufDesign.backwashWaterSource",
    waterSourceTypes: UF_WATER_SOURCE_BASE_TYPES_BW,
  },
  waterSourceBWFF: {
    name: "waterSourceBWFF",
    labelKey: "ufDesign.forwardFlushWaterSource",
    waterSourceTypes: UF_WATER_SOURCE_BASE_TYPES_BWFF,
  },
};

export const FLUX_PRECISION = 3;
